// store/report/useReportBuilderStore.ts
import { create } from "zustand";
import ReportStep from "../../models/pageModels/ReportStep";

type BuilderState = {
  reportType: string;
  steps: ReportStep[];
  showRunReportOptions: boolean;
  initialParameters: Record<string, string>;
};

type BuilderActions = {
  setReportType: (val: string) => void;
  setSteps: (steps: ReportStep[] | ((prev: ReportStep[]) => ReportStep[])) => void;
  setShowRunReportOptions: (val: boolean) => void;
  setInitialParameters: (params: Record<string, string>) => void;
  resetBuilder: () => void;
};

const initialState: BuilderState = {
  reportType: "",
  steps: [],
  showRunReportOptions: false,
  initialParameters: {},
};

export const useReportBuilderStore = create<BuilderState & BuilderActions>((set) => ({
  ...initialState,

  setReportType: (val) => set({ reportType: val }),
  setSteps: (steps) => set((s) => ({
    steps: typeof steps === "function" ? steps(s.steps) : steps,
  })),
  setShowRunReportOptions: (val) => set({ showRunReportOptions: val }),
  setInitialParameters: (params) => set({ initialParameters: params }),
  resetBuilder: () => set(initialState),
}));
